import { getCachedEmailLists } from '@/services/emailLists';
import { CountryCodes } from './CountryCodes';

/** Dominios de correo gratuito que se rechazan por defecto en validación business */
const DEFAULT_FREE_EMAIL_SLDS = [
  'gmail',
  'yahoo',
  'hotmail',
  'outlook',
  'live',
  'msn',
  'icloud',
  'aol',
  'mail',
  'protonmail',
  'zoho',
  'yandex',
  'gmx',
  'tutanota',
  'fastmail',
  'mailfence',
];

function getLists() {
  const lists = getCachedEmailLists();
  return {
    whitelist: lists?.whitelist ?? [],
    blacklist: lists?.blacklist ?? [],
  };
}

function validateEmailBusiness(email, lists = null) {
  const { whitelist, blacklist } = lists ?? getLists();
  const whitelistDomains = [];
  const domain = email.split('@')[1];
  const sld = domain ? domain.split('.')[0] : null;

  if (whitelist.includes(email)) return true;
  if (whitelistDomains.includes(sld)) return true;
  const effectiveBlacklist = [...(blacklist || []), ...DEFAULT_FREE_EMAIL_SLDS];
  if (effectiveBlacklist.includes(sld)) return false;
  if (effectiveBlacklist.includes(domain)) return false;
  return true;
}

function validateEmailAcademic(email, lists = null) {
  const { whitelist, blacklist } = lists ?? getLists();
  const allowedTld = ['edu', 'gov', 'org', 'eu', 'education', ...CountryCodes];
  const whitelistDomains = [
    'disgenet',
    'aryavaidyasala',
    'gxyyzwy',
    'arvindgavalipharmacycollege',
    'kkumail',
    'iisgm',
    'researchmar',
  ];
  const domain = email?.split('@')[1];
  const sld = domain ? domain.split('.')[0] : null;
  const tld = domain?.split('.').slice(-2).join('.');
  const simpleTld = domain?.split('.').pop();

  if (whitelist.includes(email)) return true;
  if (whitelistDomains.includes(sld)) return true;
  if (allowedTld.includes(tld) || allowedTld.includes(simpleTld)) return true;
  if (blacklist.includes(sld)) return false;
  if (blacklist.includes(domain)) return false;
  if (/^edu\.[a-z]+$/.test(tld)) return true;
  return false;
}

function validateEmail(email, isAcademic = false, lists = null) {
  const cleanedEmail = email?.trim()?.toLowerCase();
  const isValidFormat = cleanedEmail?.match(
    /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,20}|[0-9]{1,3})(\]?)$/,
  );
  if (!isValidFormat) return false;
  const isValidDomain = isAcademic
    ? validateEmailAcademic(cleanedEmail, lists)
    : validateEmailBusiness(cleanedEmail, lists);
  return isValidDomain;
}
function validateContactEmail(value) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
}

function validateNotEmpty(inputValue) {
  return inputValue?.trim() !== '';
}

export {
  validateEmail,
  validateContactEmail,
  validateNotEmpty,
  validateEmailAcademic,
  validateEmailBusiness,
};
